<div class="appNav-collapsedHidden flex-shrink-0" [class.pointer-events-none]="ACLService.isDemoUser()">
  <button
    #toggleOrgRef
    class="relative flex items-center min-h-12 w-full"
    (click)="toggleOrgRef.value = toggleOrgRef.value ? '' : 'value'"
  >
    <!-- Logo -->
    <img *ngIf="logoUrl" class="w-full h-full" [src]="logoUrl" [attr.alt]="currentOrg.name" />
    <!-- Title -->
    <span *ngIf="!logoUrl" class="text-xs font-weight-500 px-5 text-overflow" [innerHTML]="currentOrg.name"></span>
    <!-- Collapse icon -->
    <div class="absolute-center right-2 flex items-center justify-center w-4 h-4" *ngIf="!ACLService.isDemoUser()">
      <span class="i i-chevron-down text-xs transition-transform" [class.rotate-180]="toggleOrgRef.value"></span>
    </div>
  </button>
  <!-- Menu -->
  <div
    class="appNav-organization-menu -ml-1"
    [class.is-shown]="toggleOrgRef.value"
    [style.height.px]="currentUser.organizations.length > 1 ? (currentUser.organizations.length + 1) * 44 : 44"
  >
    <ng-scrollbar #scrollbarRef [position]="'invertY'" [visibility]="'hover'">
      <div scrollViewport cdkScrollable>
        <div class="pl-4 pr-3">
          <ng-container *ngIf="currentUser.organizations.length > 1">
            <a
              *ngFor="let org of currentUser.organizations"
              class="flex items-center h-9 bg-gray-200 rounded-sm text-xs pl-4 pr-2 mb-2"
              [href]="getOrgIndexLink(org)"
              [innerHTML]="org.name"
              (click)="toggleOrgRef.value = ''"
            ></a>
          </ng-container>
          <a routerLink="/accounts/organization" class="btn btn--primary w-full p-0 mb-2">{{ t("createOrg") }}</a>
        </div>
      </div>
    </ng-scrollbar>
  </div>
</div>

<!-- Collapsed icon -->
<div
  *ngIf="currentOrg.name"
  class="appNav-organization-icon appNav-collapsedVisible flex-shrink-0 items-center justify-center h-12"
>
  <span class="i i-house-2"></span>
</div>
